import Flickity from 'flickity';
export default class CX {
  constructor() {
    if (!document.querySelector('.js-cx-carousel')) return;

    this.$phones = document.querySelectorAll('.js-cx-phone');
    this.$buttons = document.querySelectorAll('.js-cx-btn');

    this.$buttons.forEach(($btn, index) => {
      $btn.addEventListener('click', () => {

        this.$buttons.forEach(($btnJ, jIndex) => {
          $btnJ.classList.remove('is-active');
        });

        this.$phones.forEach(($phone, jIndex) => {
          $btn.classList.remove('is-active');
          $phone.classList.remove('is-active');
        });

        $btn.classList.add('is-active');
        this.$phones[index].classList.add('is-active');
      });
    });

    if (window.innerWidth < 1024) {
      this.carousel = new Flickity('.js-cx-carousel', {
        pageDots: true,
        prevNextButtons: false,
        imagesLoaded: true,
        contain: true,
        wrapAround: true
      });

      window.dispatchEvent(new Event('resize'));
    }
  }
}